import React, { useEffect } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import DashboardIcon from '@material-ui/icons/Dashboard';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import ListIcon from '@material-ui/icons/List';

// import jwt_decode from 'jwt-decode';
import jwtDecode from './../services/jwt'
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import Collapse from '@material-ui/core/Collapse';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import BarChartIcon from '@material-ui/icons/BarChart';
import List from '@material-ui/core/List';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PhoneMissedIcon from '@material-ui/icons/PhoneMissed';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import PhoneCallbackIcon from '@material-ui/icons/PhoneCallback';
import PhonePausedIcon from '@material-ui/icons/PhonePaused';
import PersonIcon from '@material-ui/icons/Person';

export default function ListItems({
  titleHeader = '',
  data=[]
}){

  const [open, setOpen] = React.useState(false);
  const [openPausa, setOpenPausa] = React.useState(false);
  const [openRelatorios, setOpenRelatorios] = React.useState(false);
  const [showOpe, setShowOpe] = React.useState(false);
  const [openChamadas, setOpenChamadas] = React.useState(false);
  const [openGerenciamento, setOpenGerenciamento] = React.useState(false);
  const [openGraficos, setOpenGraficos] = React.useState(false);
  const [permissionUserCrud, setPermissionUserCrud] = React.useState(false);
  const [uri, setUri] = React.useState('');


  useEffect(() => {
    let urlArray = window.location.href.split('/');
    urlArray.shift();
    urlArray.shift();
    urlArray.shift();
    if(urlArray.length>0 && urlArray[0]==='relatorios'){
      setOpenRelatorios(true);     
      if(urlArray.length>1){
        setOpenPausa(urlArray[1]==='pausa' || urlArray[1]==='pausa-sintetica');
      }
    }   
    const uriParam = '/'+urlArray.join('/');
    setUri(uriParam)
    setOpenChamadas(uriParam==='/relatorios/atendidas' || 
      uriParam==='/relatorios/realizadas' ||
      uriParam==='/relatorios/chamadas/mapa-atendimento')
    setOpen(uriParam==='/clientes' || uriParam=='/usuarios' 
      || uriParam==='/operadores' || uriParam==='/filas' 
      || uriParam==='/attendance-pause' || uriParam==='/audios')
    setOpenGerenciamento(uriParam==='/gerencia' || uriParam==='/gerencia/logins' || uriParam==='/gerencia/delay');
    // selected={uri==="/gerencia/logins"}
  //   loadData()
  }, [])

  useEffect(() => {
    try {
      const { data } = jwtDecode(localStorage.getItem('token'))
      // const { data } = jwt_decode(localStorage.getItem('token'))
      const adm = data.user.roles.find((ro)=> ro.role==='adm' || ro.role==='user' )
      setShowOpe(typeof adm!=='undefined')
      const userPermission = data.user.roles.find((ro)=> ro.role==='adm' )
      setPermissionUserCrud(typeof userPermission!=='undefined')      
    } catch (error) {
      localStorage.setItem('token', '');
      window.location = `/login`;      
    }
  }, [])
  
  useEffect(() => {    
    setOpenGraficos(uri==="/graficos/tme"
    || uri==="/graficos/tma" 
    || uri==="graficos/pausas"
  || window.location.hash==="#graficos")
  }, [])

  const renderRelatorios = () => {
    return <Collapse in={openRelatorios} timeout="auto" unmountOnExit>
      <Link component={RouterLink} to="/relatorios/login">
        <ListItem button selected={uri==="/relatorios/login"}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="Logins / Logout" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/relatorios/abandonadas">
        <ListItem button selected={uri==="/relatorios/abandonadas"}>
          <ListItemIcon>
            <PhoneMissedIcon />
          </ListItemIcon>
          <ListItemText primary="Abandonadas" />
        </ListItem>
      </Link> 
      <Link component={RouterLink} to="/relatorios/abandonadas-atendidas">
        <ListItem button selected={uri==="/relatorios/abandonadas-atendidas"} style={{ 
          whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
          }}>
          <ListItemIcon>
            <SyncAltIcon />
          </ListItemIcon>
          <ListItemText  primary="Abandonadas não Atendendidas" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/relatorios/sintetico">
        <ListItem button selected={uri==="/relatorios/sintetico"}>
          <ListItemIcon>
            <ListIcon />
          </ListItemIcon>
          <ListItemText primary="Relatório Sintético" />
        </ListItem>
      </Link>
      <Link>
        <ListItem button  onClick={()=>{
          setOpenPausa(!openPausa)
          }}>
          <ListItemIcon>
            <PhonePausedIcon />
          </ListItemIcon>
          <ListItemText primary="Pausas" />
          {openPausa ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Link>
      <Collapse in={openPausa} timeout="auto" unmountOnExit>
        <Link component={RouterLink} to="/relatorios/pausa">
          <ListItem button selected={uri==="/relatorios/pausa"}>
            <ListItemText primary="Analítica" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
        <Link component={RouterLink} to="/relatorios/pausa-sintetica">
          <ListItem button selected={uri==="/relatorios/pausa-sintetica"}>
            <ListItemText primary="Sintética" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
      </Collapse>
      <Link button="true"  onClick={()=>{
          setOpenChamadas(!openChamadas)
          }}>
        <ListItem button>
          <ListItemIcon>
            <PhoneCallbackIcon />
          </ListItemIcon>
          <ListItemText primary="Chamadas" />
          {openChamadas ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Link>
      <Collapse in={openChamadas} timeout="auto" unmountOnExit>
        {/* <Link component={RouterLink} to="/relatorios/atendidas">
          <ListItem button selected={uri==="/relatorios/atendidas"}>
            <ListItemText primary="Atendidas" style={{marginLeft: 56}} />
          </ListItem>
        </Link> */}
        <Link component={RouterLink} to="/relatorios/atendidas">
          <ListItem button selected={uri==="/relatorios/atendidas"}>
            <ListItemText primary="Atendidas" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
        <Link component={RouterLink} to="/relatorios/atendidas-clientes">
          <ListItem button selected={uri==="/relatorios/atendidas-clientes"}>
            <ListItemText primary="Clientes" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
        <Link component={RouterLink} to="/relatorios/realizadas">
          <ListItem button selected={uri==="/relatorios/realizadas"}>
            <ListItemText primary="Realizadas" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
        <Link component={RouterLink} to="/relatorios/chamadas/mapa-atendimento">
          <ListItem button selected={uri==="/relatorios/chamadas/mapa-atendimento"}>
            <ListItemText primary="Mapa de atendimento" style={{marginLeft: 56}} />
          </ListItem>
        </Link>
      </Collapse>
    </Collapse>
  }
  const renderCadastros = () => {
    return <Collapse in={open} timeout="auto" unmountOnExit>  
      <Link component={RouterLink} to="/clientes">
        <ListItem button selected={uri==="/clientes"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Clientes" />
        </ListItem>
      </Link>
      { permissionUserCrud &&
      <Link component={RouterLink} to="/usuarios">
        <ListItem button selected={uri==="/usuarios"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Usuários" />
        </ListItem>
      </Link>
      }
      { showOpe &&
      <Link component={RouterLink} to="/operadores">
        <ListItem button selected={uri==="/operadores"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Operadores" />
        </ListItem>
      </Link>
      }
      <Link component={RouterLink} to="/filas">
        <ListItem button selected={uri==="/filas"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Filas" />
        </ListItem>
      </Link>
      {/* <Link component={RouterLink} to="/ura">
        <ListItem button>
          <ListItemIcon>
            <PeopleOutlineIcon />
          </ListItemIcon>
          <ListItemText primary="URA" />
        </ListItem>
      </Link> */}
      <Link component={RouterLink} to="/attendance-pause">
        <ListItem button selected={uri==="/attendance-pause"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Motivos de pausa" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/audios">
        <ListItem button selected={uri==="/audios"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Áudios" />
        </ListItem>
      </Link>
    </Collapse>
  }
  const renderGerenciamento = () => {
    return <Collapse in={openGerenciamento} timeout="auto" unmountOnExit>  
      <Link component={RouterLink} to="/gerencia/logins">
        <ListItem button selected={uri==="/gerencia/logins"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Logins" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/gerencia/delay">
        <ListItem button selected={uri==="/gerencia/delay"}>
          <ListItemIcon>
            <AddCircleOutlineOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Tempo para início" />
        </ListItem>
      </Link>
    </Collapse>
  }
  
  const renderGraficos = () => {
    return <Collapse in={openGraficos} timeout="auto" unmountOnExit>  
      <Link component={RouterLink} to="/graficos/tudo">
        <ListItem button selected={uri==="/graficos/tudo"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItem>
      </Link>
      {/* <Link component={RouterLink} to="/graficos/tme">
        <ListItem button selected={uri==="/graficos/tme"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="TME" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/graficos/tma">
        <ListItem button selected={uri==="/graficos/tma"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="TMA" />
        </ListItem>
      </Link> */}
      <Link component={RouterLink} to="/graficos/vag">
        <ListItem button selected={uri==="/graficos/vag"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Vol. atd. geral" />
        </ListItem>
      </Link>      
      <Link component={RouterLink} to="/graficos/vau">
        <ListItem button selected={uri==="/graficos/vau"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Vol. atd. usuário" />
        </ListItem>
      </Link> 
      <Link component={RouterLink} to="/graficos/pausas">
        <ListItem button selected={uri==="/graficos/pausas"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Pausas" />
        </ListItem>
      </Link>
      <Link component={RouterLink} to="/graficos/perguntas">
        <ListItem button selected={uri==="/graficos/perguntas"}>
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText primary="Pesquisas" />
        </ListItem>
      </Link>
    </Collapse>
  }

  return (<div>
    <List component="div" disablePadding >
      <Link component={RouterLink} to="/perfil">
        <ListItem button href="/perfil" selected={uri==="/" || uri==="/perfil"}>
          <ListItemIcon>
            <PersonPinIcon />
          </ListItemIcon>
          <ListItemText primary="Meu Perfil" />
        </ListItem>
      </Link>
      <ListItem selected={uri==="/graficos/tme"
        || uri==="/graficos/tma" 
        || uri==="graficos/pausas"
        || uri==="graficos/vag"
        || uri==="graficos/vau"
        || uri==="graficos/tudo"
      || window.location.hash==="#graficos"}  button  onClick={()=>{
        setOpenGraficos(!openGraficos)
        window.location.hash='#graficos';
      }}>
        <ListItemIcon>
          { openGraficos ?
           <DashboardIcon /> :
           <DashboardOutlinedIcon />  }
        </ListItemIcon>
        <ListItemText primary="Gráficos" />
        {openGraficos ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
        { renderGraficos() }
      <ListItem button  onClick={()=>{
        setOpenRelatorios(!openRelatorios)
      }}>
        <ListItemIcon>
          { openRelatorios ?
           <InsertDriveFileIcon /> :
           <InsertDriveFileOutlinedIcon />  }
        </ListItemIcon>
        <ListItemText primary={'Relatórios'} />
        {openRelatorios ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      { renderRelatorios() }
      <ListItem button  onClick={()=>{
        setOpen(!open)
      }}>
        <ListItemIcon>
          <AddCircleIcon />
        </ListItemIcon>
        <ListItemText primary={'Cadastro'} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      { renderCadastros() }      
      <ListItem button  onClick={()=>{
        setOpenGerenciamento(!openGerenciamento)
      }}>
        <ListItemIcon>
          <AddCircleIcon />
        </ListItemIcon>
        <ListItemText primary={'Gerencial'} />
        {openGerenciamento ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      { renderGerenciamento() }
    </List>
    {/* <Link component={RouterLink} to="/saas-client">
      <ListItem button href="/saas-client">
        <ListItemIcon>
          <BusinessIcon />
        </ListItemIcon>
        <ListItemText primary="Gerenciar Saas" />
      </ListItem>
    </Link> */}
  </div>)
}
